const key = ''
export default
{
  key
}
